import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import Rulers, { Props } from '../_components/Rulers';

const mapStateToProps = (store:Store, props:Props) => ({
	viewerWidth: store.getIn(['create', 'viewer', 'width']),
	viewerHeight: store.getIn(['create', 'viewer', 'height']),
	documentOffsetX: store.getIn(['create', 'document', 'offsetX']),
	documentOffsetY: store.getIn(['create', 'document', 'offsetY']),
	documentWidth: store.getIn(['create', 'document', 'width']) * store.getIn(['create', 'document', 'dpi']),
	documentHeight: store.getIn(['create', 'document', 'height']) * store.getIn(['create', 'document', 'dpi']),
	documentDPI: store.getIn(['create', 'document', 'dpi']),
	documentUnits: store.getIn(['create', 'document', 'units']),
});

export default connect(
	mapStateToProps,
	null
)(Rulers);